import { useEffect } from "react";
import { useServerError } from "@/hooks/useServerError";
import { setServerErrorHandler } from "@/services/api";

/**
 * ServerErrorInitializer - Sets up the global server error handler for API calls
 * This component should be rendered once at the root of the application
 * to connect the API service with the ServerErrorContext
 */
export default function ServerErrorInitializer() {
  const { setServerError } = useServerError();

  useEffect(() => {
    // Set up the global server error handler
    setServerErrorHandler((error: Error) => {
      setServerError(error);
    });

    // Clean up on unmount - set to null to avoid memory leak
    return () => {
      setServerErrorHandler(null);
    };
  }, [setServerError]);

  return null;
}